import Inquiry from './inquiry';

export default Inquiry;
